// Lista oficial dos 22 modelos V18 — exibida na UI.
// O backend mapeia para modelos reais do Lovable AI Gateway.
export type ModelMeta = {
  id: string;
  label: string;
  vendor: string;
  family: "frontier" | "fast" | "thinking" | "code" | "open";
  costPer1M: number;
  contextK: number;
  hue: number; // 0-360 para badge color
};

export const MODELS: ModelMeta[] = [
  { id: "grok-4.20",        label: "Grok 4.20",          vendor: "xAI",        family: "frontier", costPer1M: 5.0,  contextK: 256, hue: 200 },
  { id: "claude-opus-4.7",  label: "Claude Opus 4.7",    vendor: "Anthropic",  family: "frontier", costPer1M: 15,   contextK: 500, hue: 30  },
  { id: "claude-sonnet-4.6",label: "Claude Sonnet 4.6",  vendor: "Anthropic",  family: "fast",     costPer1M: 3,    contextK: 400, hue: 25  },
  { id: "gpt-5.4",          label: "GPT-5.4",            vendor: "OpenAI",     family: "frontier", costPer1M: 10,   contextK: 400, hue: 145 },
  { id: "gpt-5.3-codex",    label: "GPT-5.3-Codex",      vendor: "OpenAI",     family: "code",     costPer1M: 4,    contextK: 256, hue: 160 },
  { id: "gemini-3.1-pro",   label: "Gemini 3.1 Pro",     vendor: "Google",     family: "frontier", costPer1M: 7,    contextK: 1024,hue: 220 },
  { id: "gemini-3.1-ultra", label: "Gemini 3.1 Ultra",   vendor: "Google",     family: "frontier", costPer1M: 12,   contextK: 2048,hue: 230 },
  { id: "gemini-3-flash",   label: "Gemini 3 Flash",     vendor: "Google",     family: "fast",     costPer1M: 0.5,  contextK: 1024,hue: 195 },
  { id: "llama-4-maverick", label: "Llama 4 Maverick",   vendor: "Meta",       family: "open",     costPer1M: 1.2,  contextK: 256, hue: 280 },
  { id: "llama-4-scout",    label: "Llama 4 Scout",      vendor: "Meta",       family: "fast",     costPer1M: 0.4,  contextK: 128, hue: 285 },
  { id: "deepseek-v3.2",    label: "DeepSeek V3.2",      vendor: "DeepSeek",   family: "thinking", costPer1M: 1.5,  contextK: 128, hue: 320 },
  { id: "deepseek-v4",      label: "DeepSeek V4",        vendor: "DeepSeek",   family: "frontier", costPer1M: 4,    contextK: 256, hue: 325 },
  { id: "qwen-3.6",         label: "Qwen 3.6",           vendor: "Alibaba",    family: "open",     costPer1M: 0.8,  contextK: 128, hue: 0   },
  { id: "qwen3-coder-480b", label: "Qwen3-Coder-480B",   vendor: "Alibaba",    family: "code",     costPer1M: 2,    contextK: 256, hue: 10  },
  { id: "glm-5.1",          label: "GLM-5.1",            vendor: "Zhipu",      family: "open",     costPer1M: 0.6,  contextK: 128, hue: 90  },
  { id: "glm-4.7-thinking", label: "GLM-4.7 Thinking",   vendor: "Zhipu",      family: "thinking", costPer1M: 1.4,  contextK: 128, hue: 100 },
  { id: "kimi-k2.5",        label: "Kimi K2.5",          vendor: "Moonshot",   family: "fast",     costPer1M: 1,    contextK: 200, hue: 50  },
  { id: "kimi-k2-thinking", label: "Kimi K2 Thinking",   vendor: "Moonshot",   family: "thinking", costPer1M: 2,    contextK: 200, hue: 55  },
  { id: "minimax-m2.7",     label: "MiniMax M2.7",       vendor: "MiniMax",    family: "fast",     costPer1M: 0.7,  contextK: 128, hue: 340 },
  { id: "mistral-large-3",  label: "Mistral Large 3",    vendor: "Mistral",    family: "frontier", costPer1M: 3,    contextK: 128, hue: 15  },
  { id: "gemma-4-31b",      label: "Gemma 4 31B",        vendor: "Google",     family: "open",     costPer1M: 0.3,  contextK: 64,  hue: 210 },
  { id: "command-r-plus",   label: "Command R+",         vendor: "Cohere",     family: "fast",     costPer1M: 1,    contextK: 128, hue: 350 },
  { id: "r1",               label: "R1",                 vendor: "DeepSeek",   family: "thinking", costPer1M: 1.6,  contextK: 128, hue: 310 },
];

export const MODEL_BY_ID = Object.fromEntries(MODELS.map((m) => [m.id, m]));

export function modelBadgeStyle(id: string): React.CSSProperties {
  const m = MODEL_BY_ID[id];
  const hue = m?.hue ?? 200;
  return {
    backgroundColor: `hsl(${hue} 80% 14%)`,
    color: `hsl(${hue} 95% 75%)`,
    borderColor: `hsl(${hue} 80% 35% / 0.6)`,
    boxShadow: `0 0 10px hsl(${hue} 100% 55% / 0.25)`,
  };
}
